import type * as React from 'react';

import Icon from '@dx-ui/osc-icon';
import { useTranslation } from 'next-i18next';
import { Speedbump, useSpeedbump } from '@dx-ui/osc-speedbump';
import { useRouter } from 'next/router';
import { Heading, Link, Text } from '@dx-ui/global-ui-prism';

export const customerServiceNumber = '1-800-817-5143';
export const internationalNumbersLink = 'https://help.hilton.com/s/article/Global-support-numbers';

const HelpBlock: React.FC = () => {
  const { t } = useTranslation('osc-login');
  const language = useRouter().locale || 'en';
  const { onShow, onHide, isVisible, onContinue } = useSpeedbump(language);

  return (
    <>
      <Speedbump isShowing={isVisible} onContinue={onContinue} onClose={onHide} />
      <div className="mx-auto w-[85%] max-w-[650px] px-0 py-16 text-center xl:py-40">
        <Heading level={1} size="3xl" className="mb-5 mt-11">
          {t('helpBlock.helpBlockTitle')}
        </Heading>
        <Text size="lg" className="mb-12 px-8 leading-snug">
          {t(`helpBlock.helpBlockText`)}
        </Text>
        <section className="mx-auto mb-10 bg-surface-legacy p-8">
          <div className="mb-3 flex items-center justify-center">
            <Icon name="telephone" variant="solid" size="md" className="-ms-3 me-2 sm:-ms-8" />
            <Text as="span" size="lg" aria-hidden="true">
              {t(`helpBlock.USandCanada`)}
            </Text>
            <span className="mx-1">|</span>
            <span className="sr-only">{t(`helpBlock.USandCanadaA11y`)}</span>
            <span className="sr-only">{t('helpBlock.phone')}</span>
            <Text as="span" size="lg">
              {customerServiceNumber}
            </Text>
          </div>
          <Link url={internationalNumbersLink} target="_parent" onClick={onShow}>
            {t('helpBlock.internationalNumbers')}
          </Link>
        </section>
      </div>
    </>
  );
};

export default HelpBlock;
